import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDatabase } from '@fortawesome/free-solid-svg-icons';
import { Tooltip } from '@mui/material';
import leeuw from '../../assets/leeuw.png';
import coq from '../../assets/coq.png';

/**
 * A single customer-database card for the Environment screen.
 * Renders in two layouts depending on `view`:
 *   - 'compact'  : dense horizontal row (default)
 *   - 'regular'  : logo-forward vertical card
 * Region (VL/WL) is shown with the existing PNG icons (leeuw / coq).
 * Logo-less databases fall back to the FontAwesome database icon.
 */
const DatabaseCard = (props) => {
    const { data, view, theme, func, t } = props;

    const isTest = data.cust_is_test === "1";
    const isLocal = data.cust_is_local === "1";
    const isLive = !isTest && !isLocal;
    const env = isTest ? 'test' : (isLocal ? 'local' : 'live');

    const customerLabel = (data.alt_name && data.alt_name.trim() !== "")
        ? data.alt_name
        : (t ? t('noCustomerLinked') : 'Geen klant gekoppeld');
    const numLabel = data.cust_no ? ('#' + data.cust_no) : '';

    const hasRegion = (data.cust_zone === "VL" || data.cust_zone === "WL");
    const regionBadge = (extraClass) => hasRegion && (
        <Tooltip title={data.cust_zone === "VL" ? 'VLAANDEREN' : 'WALLONIE'} arrow>
            <span className={'environment__region_badge ' + (extraClass || '')}>
                <img
                    alt={data.cust_zone === "VL" ? 'Vlaanderen' : 'Wallonie'}
                    src={data.cust_zone === "VL" ? leeuw : coq}
                />
            </span>
        </Tooltip>
    );

    const logoTile = (data.logo && data.logo !== "")
        ? <img alt="logo" className="environment__logo_img" src={data.logo} loading="lazy" />
        : <FontAwesomeIcon icon={faDatabase} className="environment__logo_icon" color={theme === 'dark' ? 'white' : 'black'} />;

    const trainingLabel = t ? t('training') : 'TRAINING';
    const lokaalLabel = t ? t('lokaal') : 'LOKAAL';

    if (view === 'regular') {
        return (
            <div className={"environment__card_regular environment__card_" + theme + " " + theme} onClick={() => { func(); }}>
                {!isLive && <div className={"environment__topstrip environment__env_" + env}></div>}
                <div className="environment__banner">
                    {isTest && <span className="environment__pill environment__pill_test">{trainingLabel}</span>}
                    {isLocal && <span className="environment__pill environment__pill_local">{lokaalLabel}</span>}
                    {isLive && <span className="environment__pill_live"><span className="environment__live_dot"></span>LIVE</span>}
                    {regionBadge('environment__region_badge_abs')}
                    <div className="environment__banner_logo">{logoTile}</div>
                </div>
                <div className="environment__footer">
                    <div className="environment__footer_text">
                        <div className="environment__card_name">{data.description}</div>
                        <div className="environment__card_sub">
                            {customerLabel} {numLabel && <span className="environment__num_chip">{numLabel}</span>}
                        </div>
                    </div>
                    <span className="environment__open_affordance">&rsaquo;</span>
                </div>
            </div>
        );
    }

    // compact (default)
    return (
        <div className={"environment__card_compact environment__card_" + theme + " " + theme} onClick={() => { func(); }}>
            {!isLive && <span className={"environment__spine environment__env_" + env}></span>}
            <div className="environment__logo_tile">{logoTile}</div>
            <div className="environment__card_mid">
                <div className="environment__card_row1">
                    <span className="environment__card_name">{data.description}</span>
                    {isTest && <span className="environment__pill environment__pill_test">{trainingLabel}</span>}
                    {isLocal && <span className="environment__pill environment__pill_local">{lokaalLabel}</span>}
                </div>
                <div className="environment__card_row2">
                    <span className="environment__card_sub">{customerLabel}</span>
                    {numLabel && <span className="environment__num_chip">{numLabel}</span>}
                </div>
            </div>
            {regionBadge()}
        </div>
    );
};

export default DatabaseCard;
